/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react';
import styled from 'styled-components';

import StyledButton from './StyledButton';
import ImageAdd from '../assets/img/add.words.svg';
import ImageClose from '../assets/img/close.svg';
import { AniSlideInUp } from './animates';
const AddButton = styled(StyledButton)`
  background-image: url(${ImageAdd});
  &.close {
    background-image: url(${ImageClose});
    
  }
`;
const StyledBtnWrapper = styled.div`
  z-index: 998;
  position: fixed;
  left: 1rem;
  top: 1rem;
  margin-right: 0.5rem;
  .tip {
    position: absolute;
    right: -4rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.6rem;
    background: rgba(2, 2, 2, 0.6);
    padding: 0.3rem;
    &.hidden {
      visibility: hidden;
    }
  }
`;
const StyledModal = styled.section`
  z-index: 998;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px black;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(2, 2, 2, 0.9);
  padding: 1rem;
  &.visible {
    animation: ${AniSlideInUp} 1s;
  }
  .title {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  .content {
    margin-top: 1rem;
    line-height: 1.5;
    padding: 0 4rem;
    .way {
      margin-bottom: 1.4rem;
      .head {
        font-size: 1.4rem;
        font-weight: 800;
        margin-bottom: 0.4rem;
      }
      .con {
        font-size: 1.2rem;
        em {
          font-weight: 800;
          user-select: text;
        }
        a {
          font-weight: 800;
          margin: 0 0.3rem;
        }
      }
    }
  }
`;
const Modal = ({ visible = false }) => {
  return (
    <StyledModal className={visible ? 'visible' : 'hidden'}>
      <h2 className="title">👇通过以下方式贡献情话👇</h2>
      <div className="content">
        <div className="way">
          <h3 className="head">方式一：</h3>
          <p className="con">
            通过腾讯文档，在线提交：
            <a
              href="https://docs.qq.com/form/page/DV3JzQlJnelFPQ0lI"
              target="_blank"
              rel="noopener noreferrer"
            >
              腾讯文档
            </a>
          </p>
        </div>
        <div className="way">
          <h3 className="head">方式二：</h3>
          <p className="con">
            关注微信公众号 CCCiTU 一起在公众号的文章评论区讨论
          </p>
        </div>
      </div>
    </StyledModal>
  );
};
export default function AddWords() {
  const [expand, setExpand] = useState(false);
  const handleClick = () => {
    setExpand((prev) => !prev);
  };

  return (
    <>
      <Modal visible={expand} />
      <StyledBtnWrapper>
        <AddButton className={`${expand ? 'close' : ''} visible`} onClick={handleClick}></AddButton>
        <div className={`tip ${expand ? 'hidden' : ''}`}>👈贡献情话</div>
      </StyledBtnWrapper>
    </>
  );
}
